import styled, { css } from 'styled-components';

export const RadiosWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    padding-bottom: 24px;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding-bottom: 16px;
    }
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      flex-direction: column;
    }
  `}
`;

export const PaymentInformation = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0;
    padding-bottom: 24px;
  `}
`;

export const RadioWrapper = styled.label`
  ${({ theme }) => css`
    border: 1px solid ${theme.v2.colors.feedback.canceledPure};
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    gap: 2px;
    min-width: fit-content;
    padding: 20px;
  `}
`;

export const HideInIframeLoadWrapper = styled.div`
  ${({ shouldHide }) => css`
      display: ${shouldHide ? 'none' : 'block'};
  `}
`;

export const RadioLabel = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0;
  `}
`;

export const IframeWrapper = styled.div`
  ${({ shouldHide }) => css`
    display: ${shouldHide ? 'none' : 'block'};
    max-width: 596px;
  `}
`;

export const AlreadyRegisteredTitle = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
    padding-bottom: 24px;
  `}
`;

export const AlreadyRegisteredWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CardInfoWrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    gap: 8px;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      align-items: start;
      flex-direction: column;
      gap: 16px;
    }
  `}
`;

export const CCNumberWrapper = styled.div`
  display: flex;
  padding-right: 16px;
`;

export const CCNumberBlock = styled.div`
  display: flex;
  gap: 4px;
`;

export const CCLastFourWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
`;

export const CensuredNumber = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.lowDark};
    border-radius: 4px;
    height: 4px;
    width: 4px;
  `}
`;

export const CCExpireDate = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0;
  `}
`;

export const CCLastFour = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0;
  `}
`;

export const NextPaymentWarning = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
    padding-top: 16px;
  `}
`;

export const RenewalDate = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    margin: 0;
    padding-bottom: 14px;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding-bottom: 8px;
    }
  `}
`;

export const CCFlag = styled.img``;

export const CCFlagWrapper = styled.div`
  display: flex;
  svg {
    width: 20px;
  }
`;

export const FlagNumberWrapper = styled.div`
  display: flex;
  gap: 16px;
`;

export const SkeletonFlagsWrapper = styled.div`
  display: flex;
  gap: 8px;
  padding: 16px 0px;
`;

export const SkeletonRadioWrapper = styled.div`
  display: flex;
  gap: 24px;
  padding-top: 24px;
`;

export const IframeSkeletonWrapper = styled.div`
  display: flex;
  flex: 1 1 0%;
  flex-direction: column;
  max-width: 600px;
`;

export const SkeletonFieldsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 20px;
    padding-bottom: 20px;
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      flex-wrap: wrap;
    }
  `}
`;

export const SkeletonFooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SkeletonCvvWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 20px;
    width: 47%;
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      width: 100%;
    }
  `}
`;

export const YearCCWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 20px;
    width: 53%;
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      width: 100%;
    }
  `}
`;

export const FastCheckoutButtonSkeletonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
`;
